import React from 'react'
import './App.css'
import AppRouter from './router'
import { ClaimProvider } from './claimProvider'
import { ViewThruDeviceProvider } from './viewThru'

const viewThruEnabled = process.env.REACT_APP_VIEWTHRU_ENABLED === 'true'
const viewThruEnvironment =
    process.env.REACT_APP_VIEWTHRU_ENV === 'production' ? 'production' : 'test'

function App() {
    return (
        <ViewThruDeviceProvider environment={viewThruEnvironment} enabled={viewThruEnabled}>
            <ClaimProvider>
                <div className="App">
                    <AppRouter />
                </div>
            </ClaimProvider>
        </ViewThruDeviceProvider>
    )
}

export default App
